<template>
    <div>
        {{ msg }}
    </div>
</template>

<script>
export default {
    name: "Prefixes",
    data() {
        return {
            msg: 'Prefixes Here',
        }
    },
}
</script>

<style scoped>

</style>
